import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { ParametreDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import {
    DecisionLeafNode,
    DecisionNode,
    getDecisionNode,
    decisionNodes,
    startNodeId
} from "./regimeDecisionEntree.tree";

@Component({
	model: { prop: "isManualChoice", event: "isManualChoice" }
})
export default class ModalRegimeDecisionEntreeSalarie extends Vue {
    @Prop({ default: () => [] })
    public listeMaladieRetraites!: ParametreDto[];

    @Prop({ default: false })
    public isManualChoice!: boolean;

    public visible = false;

    public history: string[] = [];

    public currentId = startNodeId;

    public mounted(): void {
        this.history = [];
        this.currentId = startNodeId;
        this.visible = true;
    }

    /**
     * @description Retourne le noeud courant de l'arbre de décision.
     * @returns Le noeud courant de l'arbre de décision.
     */
    public get currentNode(): DecisionNode | undefined {
        return getDecisionNode(this.currentId);
    }

    /**
     * @description Retourne true si le noeud courant est une feuille.
     * @returns True si le noeud courant est une feuille.
     */
    public get isLeaf(): boolean {
        return this.currentNode !== undefined && this.currentNode.type === "leaf";
    }

    /**
     * @description Retourne le noeud feuille courant.
     * @returns Le noeud feuille courant.
     */
    public get leafNode(): DecisionLeafNode | undefined {
        const n = this.currentNode;

        return n !== undefined && n.type === "leaf" ? n : undefined;
    }

    /**
     * @description Affiche le pied (questions ou feuille avec actions).
     * @returns True si le pied est visible.
     */
    public get footerRegimeDecisionVisible(): boolean {
        return (
            (this.currentNode !== undefined && this.currentNode.type === "question") ||
            this.isLeaf
        );
    }

    /**
     * @description Retourne le libellé du régime proposé.
     * @returns Le libellé du régime proposé.
     */
    public get proposedRegimeLibelle(): string {
        const leaf = this.leafNode;
        if (leaf === undefined) {
            return "";
        }
        const p = this.listeMaladieRetraites.find(x => x.Code === leaf.regimeCode);

        return p !== undefined && p.Libelle ? p.Libelle : leaf.regimeCode;
    }

    /**
     * @description Sélectionne une réponse et met à jour l'ID du noeud courant.
     * @param nextId L'ID du noeud suivant.
     */
    public onSelectAnswer(nextId: string): void {
        const next = decisionNodes[nextId];
        if (next === undefined) {
            return;
        }
        this.history.push(this.currentId);
        this.currentId = nextId;
    }

    /**
     * @description Retourne true si on peut revenir en arrière.
     * @returns True si on peut revenir en arrière.
     */
    public goBack(): void {
        if (this.history.length === 0) {
            return;
        }
        this.currentId = this.history.pop()!;
    }

    /**
     * @description Retourne true si on peut revenir en arrière.
     * @returns True si on peut revenir en arrière.
     */
    public canGoBack(): boolean {
        return this.history.length > 0;
    }

    /**
     * @description Sélectionne le choix manuel.
     */
    public manualChoice(): void {
        this.$emit("isManualChoice", true);
        this.visible = false;
    }

    /**
     * @description Applique le régime sélectionné.
     */
    public apply(): void {
        const leaf = this.leafNode;
        if (leaf === undefined) {
            return;
        }
        this.$emit("apply", leaf.regimeCode);
        this.visible = false;
    }

    /**
     * @description Ferme la modal.
     */
    public onDialogClosed(): void {
        this.$emit("closed");
    }
}



// WEBPACK FOOTER //
// ./src/components/entreeSalarie/modalRegimeDecision/modalRegimeDecisionEntreeSalarie.ts